<template>
    <div>
        <v-card-text class="pb-0 pl-7 pr-7 pt-3" v-if="!findDone">
            <v-row>
                <v-col class="pb-0" style="color:#999999; font: normal normal 600 16px/37px Apple SD Gothic Neo;">이름</v-col>
            </v-row>
            <v-row>
                <v-col class="pt-0 pb-5">
                    <v-text-field outlined hide-details dense placeholder="이름을 입력해 주세요" :error="formStatus['user_name'].err" :ref="'user_name'" v-model="formData.user_name"
                                  @keyup="checkChanged('user_name')" style="height:40px;">
                        <template v-slot:append v-if="formStatus['user_name'].err_msg">
                            <div style="color:#FF4D4D; font-size:13px; padding-top:5px;">
                                {{ formStatus['user_name'].err_msg }}
                            </div>
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="pt-0 pb-0" style="color:#999999; font: normal normal 600 16px/37px Apple SD Gothic Neo;">휴대폰 번호</v-col>
            </v-row>
            <v-row>
                <v-col class="pt-0 pb-5">
                    <v-text-field outlined hide-details dense placeholder="휴대폰 번호를 입력해 주세요" :error="formStatus['user_mdn'].err" :ref="'user_mdn'" v-model="formData.user_mdn"
                                  @keyup="checkChanged('user_mdn')" style="height:40px;">
                        <template v-slot:append v-if="formStatus['user_mdn'].err_msg || formStatus['user_mdn'].info_msg">
                            <div style="color:#FF4D4D; font-size:13px; padding-top:5px;" v-if="formStatus['user_mdn'].err_msg">
                                {{ formStatus['user_mdn'].err_msg }}
                            </div>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                    <v-btn color="#CCCCCC" width="94px" dark elevation="0" style="font-size:16px;" v-if="smsVerified">인증완료</v-btn>
                    <v-btn color="#CCCCCC" width="94px" dark elevation="0" style="font-size:16px;" v-else-if="smsSended && !smsVerified">발송완료</v-btn>
                    <v-btn color="#4E87DD" width="94px" dark elevation="0" style="font-size:16px;" v-else-if="formData.user_mdn && !smsVerified" @click="sendSms">인증받기</v-btn>
                    <v-btn color="#CCCCCC" width="94px" dark elevation="0" style="font-size:16px;" v-else>인증받기</v-btn>
                </v-col>
            </v-row>
            <v-row v-if="smsSended && !smsVerified">
                <v-col class="pt-0 pb-5">
                    <v-text-field outlined hide-details dense placeholder="인증번호를 입력해 주세요" :error="formStatus['sms_verify_value'].err" :ref="'sms_verify_value'" v-model="formData.sms_verify_value"
                                  @keyup="checkChanged('sms_verify_value')" style="height:40px;">
                        <template v-slot:append v-if="formStatus['sms_verify_value'].err_msg || formStatus['sms_verify_value'].info_msg">
                            <div style="color:#FF4D4D; font-size:13px; padding-top:5px;" v-if="formStatus['sms_verify_value'].err_msg">
                                {{ formStatus['sms_verify_value'].err_msg }}
                            </div>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                    <v-btn color="#4E87DD" width="94px" dark elevation="0" style="font-size:16px;" v-if="formData.sms_verify_value && smsSended && !smsVerified" @click="verifySms">확인</v-btn>
                    <v-btn color="#CCCCCC" width="94px" dark elevation="0" style="font-size:16px;" v-else>확인</v-btn>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-text class="pb-0 pl-7 pr-7 pt-3" v-if="findDone">
            <v-row>
                <v-col class="pb-0" style="color:#999999; font: normal normal 600 16px/37px Apple SD Gothic Neo;">조회된 아이디 입니다</v-col>
            </v-row>
            <v-row>
                <v-col class="pa-10 text-center" style="border: 1px solid #999999;font-size:18px; color:#333333;">
                    {{ userId }}
                </v-col>
            </v-row>
        </v-card-text>
    </div>

</template>

<script>
import authApi from '@/api/auth'

export default {
    data: () => ({
        formData: {
            user_name: '',
            user_mdn: '',
            sms_verify_value: '',
            tran_token: '',
        },
        formStatus: {
            user_name: {
                err: false,
                err_msg: '',
            },
            user_mdn: {
                err: false,
                err_msg: '',
            },
            sms_verify_value: {
                err: false,
                err_msg: '',
            }
        },
        smsSended: false,
        smsVerified: false,
        findDone: false,
        userID: '',
    }),
    computed: {},
    mounted() {
        this.$nextTick(() => {
            this.$refs.user_name.focus()
        })
    },
    methods: {
        doSubmit() {
            if (this.findDone) {
                this.$emit('cancel')
            } else if (this.smsSended && this.smsVerified) {
                authApi.findId({
                        auth_type: 'FIND_ADMIN_ID',
                        tran_token: this.formData.tran_token,
                    },
                    (userId, va) => {
                        va.userId = userId
                        va.findDone = true
                    }, (err, va) => {
                        va.$store.dispatch('openAlert', {
                            message: '아이디 찾기를 실패 했습니다',
                            sub_message: err
                        })
                    }, this)
            } else if (!this.smsSended) {
                this.sendSms()
            } else if (!this.smsVerified) {
                this.verifySms()
            }
        },
        goFindPW() {
            this.$emit('goFindPW')
        },
        closePopup() {
            this.$emit('cancel')
        },
        checkChanged(t) {
            let val = this.formData[t]
            let s = this.formStatus[t]
            if (!s) {
                return
            }

            if (t == 'user_name') {
                if (!val) {
                    this.updateErrStatus('user_name', true, '이름을 입력해 주세요')
                } else {
                    this.updateErrStatus('user_name', false, '')
                }
            } else if (t == 'user_mdn') {
                let mdnType = /^010[0-9+]{7,8}$/;
                if (!val) {
                    this.updateErrStatus('user_mdn', true, '휴대폰 번호를 입력해 주세요')
                } else if (!mdnType.test(val)) {
                    this.updateErrStatus('user_mdn', true, '잘못된 휴대폰 번호 형식 입니다')

                } else {
                    this.updateErrStatus('user_mdn', false, '')

                    if (this.smsSended) {
                        this.smsSended = false
                    }
                }
            }

        },
        checkFormErr() {
            for (let k in this.formStatus) {
                if (this.formStatus[k].err) {
                    return true
                }
            }

            return false
        },
        updateErrStatus(target, err, errMsg) {
            let status = this.formStatus[target]
            let ref = null

            if (!errMsg) {
                errMsg = ''
            }

            if (status) {
                status.err = err
                status.err_msg = errMsg
                if (err && ref) {
                    ref.focus()
                }
            }
        },
        sendSms() {
            let succ = true
            let userName = this.formData.user_name
            if (!userName) {
                this.updateErrStatus('user_name', true, '이름을 입력해 주세요;')
                succ = false
            }
            let userMdn = this.formData.user_mdn
            if (userMdn == '') {
                this.updateErrStatus('user_mdn', true, '휴대폰 번호를 입력해 주세요')
                succ = false
            }
            let mdnType = /^010[0-9+]{7,8}$/;
            if (!mdnType.test(userMdn)) {
                this.updateErrStatus('user_mdn', true, '잘못된 휴대폰 번호 형식 입니다')
                succ = false
            }
            if (!succ) {
                return
            }


            authApi.sendSms({
                auth_type: 'FIND_ADMIN_ID',
                user_name: userName,
                user_mdn: userMdn
            }, (tranToken, va) => {
                va.smsSended = true
                va.smsVerified = false
                va.formData.sms_verify_value = ''
                va.formData.tran_token = tranToken

                va.$nextTick(() => {
                    va.$refs.sms_verify_value.focus()
                })
            }, (err, va) => {
                let msg = '인증 문자 발송을 실패 했습니다'
                let subMsg = err

                va.$store.dispatch('openAlert', {
                    message: msg,
                    sub_message: subMsg,
                })
            }, this)
        },
        verifySms() {
            if (this.formData.sms_verify_value == '') {
                this.updateErrStatus('sms_verify_value', true, '인증번호를 입력해 주세요')
                return
            }

            authApi.verifySms({
                auth_type: 'FIND_ADMIN_ID',
                tran_token: this.formData.tran_token,
                sms_verify_value: this.formData.sms_verify_value,
            }, (verifyResult, va) => {
                if (verifyResult == 'SUCCESS' || verifyResult == 'ALREADY_VERIFIED') {
                    va.$store.dispatch('openAlert', {
                        message: '인증 되었습니다',
                        va: va,
                        closeCb: function (va) {
                            va.smsVerified = true
                            va.updateErrStatus('user_mdn', false, '')

                            va.doSubmit()
                        }
                    })
                } else {
                    let msg = '인증을 실패 했습니다'
                    let subMsg = ''
                    // NO_TRAN, ALREADY_VERIFIED, INCORRECT
                    if (verifyResult == 'NO_TRAN') {
                        subMsg = '인증 정보가 만료되었습니다'
                    } else if (verifyResult == 'INCORRECT') {
                        subMsg = '인증번호가 일치하지 않습니다'
                    }

                    va.$store.dispatch('openAlert', {
                        message: '인증번호가 일치하지 않습니다',
                        sub_message: subMsg,
                        va: va,
                        closeCb: function (va) {
                            va.formStatus.user_mdn.verified = false
                            va.formStatus.user_mdn.verified_val = ''
                        }
                    })
                }
            }, (err, va) => {
                va.$store.dispatch('openAlert', {
                    message: '인증을 실패 했습니다.',
                    va: va,
                    closeCb: function (va) {
                        va.formStatus.user_mdn.verified = false
                        va.formStatus.user_mdn.verified_val = ''
                    }
                })
            }, this)
        },
    }
}
</script>
